import TicketsSummaryContainer from './tickets-summary-container';

export default TicketsSummaryContainer;
